import React, { createContext, useContext, useState, useCallback } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog';

const DeleteConfirmationContext = createContext();

export const DeleteConfirmationProvider = ({ children }) => {
  const [dialogState, setDialogState] = useState({
    open: false,
    title: 'Confirm Delete',
    message: 'Are you sure you want to delete this item?',
    onConfirm: null,
    onCancel: null,
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
  });

  const showDeleteConfirmation = useCallback((options) => {
    return new Promise((resolve) => {
      setDialogState({
        open: true,
        title: options.title || 'Confirm Delete',
        message: options.message || 'Are you sure you want to delete this item?',
        confirmButtonText: options.confirmButtonText || 'Delete',
        cancelButtonText: options.cancelButtonText || 'Cancel',
        onConfirm: () => {
          setDialogState(prev => ({ ...prev, open: false }));
          resolve(true);
        },
        onCancel: () => {
          setDialogState(prev => ({ ...prev, open: false }));
          resolve(false);
        },
      });
    });
  }, []);

  const handleClose = useCallback(() => {
    setDialogState(prev => ({ ...prev, open: false }));
    if (dialogState.onCancel) {
      dialogState.onCancel();
    }
  }, [dialogState.onCancel]);

  const handleConfirm = useCallback(() => {
    if (dialogState.onConfirm) {
      dialogState.onConfirm();
    }
  }, [dialogState.onConfirm]);

  return (
    <DeleteConfirmationContext.Provider value={{ showDeleteConfirmation }}>
      {children}
      <ConfirmationDialog
        open={dialogState.open}
        onClose={handleClose}
        onConfirm={handleConfirm}
        title={dialogState.title}
        message={dialogState.message}
        confirmButtonText={dialogState.confirmButtonText}
        cancelButtonText={dialogState.cancelButtonText}
        confirmButtonColor="error"
      />
    </DeleteConfirmationContext.Provider>
  );
};

export const useDeleteConfirmation = () => {
  const context = useContext(DeleteConfirmationContext);
  if (!context) {
    throw new Error('useDeleteConfirmation must be used within a DeleteConfirmationProvider');
  }
  return context;
};

